module.exports = __webpack_public_path__ + "img/RJC_LP_fertigung.646563b.webp";